import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const InvestorRegistration = lazy(() => import('../../container/investor/investorRegistration'));
const InvestorList = lazy(() => import('../../container/investor/investorList'));
const InvestorUpdate = lazy(() => import('../../container/investor/investorUpdate'));
const InvestorDetails = lazy(() => import('../../container/investor/InvestorDetail/investorDetails'));

export default function InvestorRoute() {
  return (
    <Routes>
      <Route path="registration" element={<InvestorRegistration />} />
      <Route path="list" element={<InvestorList />} />
      <Route path="detail/:id" element={<InvestorDetails />} />
      <Route path="update/:id" element={<InvestorUpdate />} />
    </Routes>
  );
}
